const o="Xiii, já foi tudo :(",i="no PIX",t="OFF";export{i as DEFAULT_METHOD_LABEL,t as DISCOUNT_LABEL,o as UNAVAILABLE_LABEL};
